const template=`
<div class="formRow">
  <div class="configTitle translate">Image URL</div>
  <input class="configWidgetName" id="imageSrc" type="text" ng-model="widget.settings.imageSrc"/>
</div>`;
export default template;